import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { login, loginWithGoogle } from '../api/Auth';
import { jwtDecode } from 'jwt-decode';
import '../css/Login.css';
import { toast } from 'react-toastify';
import { AuthContext } from '../context/AuthContext'
const LOGO_URL = 'https://cdn.otaprime.com/logo-new.png';

const ALLOWED_EMAIL_DOMAIN = '@otaprime.com';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const { setUser } = useContext(AuthContext);

  const handleLogin = async () => {
    if (!email || !password) {
      toast.error('Email and password are required');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error('Enter a valid email address');
      return;
    }

    // Check if email is from @otaprime.com domain
    if (!email.endsWith(ALLOWED_EMAIL_DOMAIN)) {
      toast.error(`Only ${ALLOWED_EMAIL_DOMAIN} email addresses are allowed`);
      return;
    }

    if (password.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }

    try {
      const res = await login(email, password);
      localStorage.setItem('token', res.token);
      toast.success('Logged in successfully!');
      const decoded = jwtDecode(res.token);
      setUser(decoded);
      navigate('/');
    } catch (err) {
      toast.error('Invalid credentials');
    }
  };

  const handleGoogleLoginSuccess = async (credentialResponse: any) => {
    try {
      // Decode Google JWT to check email domain
      const googleToken = credentialResponse.credential;
      if (!googleToken) {
        toast.error('Failed to get Google credentials');
        return;
      }

      const decoded = jwtDecode(googleToken) as any;
      const userEmail = decoded.email;

      // Check if email is from @otaprime.com domain
      if (!userEmail || !userEmail.endsWith(ALLOWED_EMAIL_DOMAIN)) {
        toast.error(`Only ${ALLOWED_EMAIL_DOMAIN} email addresses are allowed`);
        return;
      }

      // Send credential to backend
      const res = await loginWithGoogle(googleToken);
      localStorage.setItem('token', res.token);
      toast.success('Logged in successfully with Google!');
      const userDecoded = jwtDecode(res.token);
      setUser(userDecoded);
      navigate('/');
    } catch (err: any) {
      toast.error(err.message || 'Failed to login with Google');
    }
  };

  const handleGoogleLoginError = () => {
    toast.error('Google login failed');
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="logo-crop-1"> <img className="login-logo" src={LOGO_URL} alt="OTA Prime" /> </div>
        <h2>Login</h2>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />
        <button onClick={handleLogin}> Login </button>
        
        <div className="login-divider">
          <span>OR</span>
        </div>
        
        <div className="google-login-wrapper">
          <GoogleLogin
            onSuccess={handleGoogleLoginSuccess}
            onError={handleGoogleLoginError}
            useOneTap={false}
            itp_support={true}
            theme="outline"
            size="large"
            text="continue_with"
            shape="rectangular"
          />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
